import React from 'react'
import "./HowToMint.css"

export default function HowToMint() {
  return (
    <div className=''>
        <div className="how_to_mint_sect">
  <div className="container how_to_mint_container">
    <div className="bithu_title_section md-pb-20">
      <h2>
        Easy steps
        <img src="assets/images/title_shapes.svg" alt="" />
      </h2>
      <h3>How to mint</h3>
    </div>
    <div className="how_to_mint_shadow">
      <img src="assets/images/  -Grad.png" alt="" />
    </div>
    <div className="how_to_mint_content">
      <ul>
        <li>
          <h4 className="green">1</h4>
          <p>Connect Your Wallet</p>
        </li>
        <li>
          <h4 className="blue">2</h4>
          <p>Select Your Quantity</p>
        </li>
        <li>
          <h4 className="yellow">3</h4>
          <p>Confirm the Transaction</p>
        </li>
        <li>
          <h4 className="red">4</h4>
          <p>Receive Your NFTs</p>
        </li>
      </ul>
    </div>
  </div>
</div>

    </div>
  )
}
